import React from "react";
import newsData from "../data/news.json";

interface NewsItem {
    id: string;
    title: string;
    content: string;
    type: string;
    color: string;
    priority: number;
}

interface NewsModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAcknowledge: () => void;
}

const NewsModal: React.FC<NewsModalProps> = ({
    isOpen,
    onClose,
    onAcknowledge
}) => {
    if (!isOpen) return null;

    const handleAcknowledge = () => {
        onAcknowledge();
        onClose();
    };

    const getColorClass = (color: string) => {
        const colorMap: { [key: string]: string } = {
            blue: "border-blue-500",
            green: "border-green-500",
            yellow: "border-yellow-500",
            purple: "border-purple-500",
            red: "border-red-500"
        };
        return colorMap[color] || "border-gray-500";
    };

    const sortedNews = [...newsData.news].sort((a, b) => a.priority - b.priority);

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-11/12 max-w-2xl max-h-[80vh] overflow-y-auto">
                <div className="flex justify-between items-start mb-4">
                    <h2 className="text-xl font-semibold">{newsData.title}</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 text-2xl"
                    >
                        ×
                    </button>
                </div>
                
                {/* Dynamic news content from JSON */}
                <div className="news-content mb-6">
                    <div className="mb-4">
                        <h3 className="font-semibold text-lg mb-2">Welcome to management portal!</h3>
                        <p className="text-gray-700 mb-3">Here are the latest updates and announcements:</p>
                        
                        <div className="space-y-3">
                            {sortedNews.map((item: NewsItem) => (
                                <div key={item.id} className={`border-l-4 ${getColorClass(item.color)} pl-4`}>
                                    <h4 className="font-medium">{item.title}</h4>
                                    <p className="text-sm text-gray-600">{item.content}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                
                <div className="flex justify-end space-x-2">
                    <button
                        onClick={onClose}
                        className="bg-gray-300 text-black py-2 px-4 rounded hover:bg-gray-400"
                    >
                        Close
                    </button>
                    <button
                        onClick={handleAcknowledge}
                        className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
                    >
                        Acknowledge
                    </button>
                </div>
            </div>
        </div>
    );
}

export default NewsModal;
